var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.624 7.087c-2.6.832-4.056 3.016-4.056 5.252 0 .832.208.936.416.936.416 0 .676-.468 1.612-.468 1.248 0 2.444.988 2.444 2.756s-1.352 3.068-3.12 3.068c-2.392 0-3.9-2.08-3.9-4.94 0-3.588 2.236-7.228 6.24-8.32zm8.943 0c-2.6.832-4.056 3.016-4.056 5.252 0 .832.209.936.417.936.415 0 .675-.468 1.611-.468 1.249 0 2.444.988 2.444 2.756s-1.352 3.068-3.12 3.068c-2.391 0-3.9-2.08-3.9-4.94 0-3.588 2.237-7.228 6.24-8.32z"
})));
export default SvgQuote;